import React from "react";
import { css, FlattenSimpleInterpolation } from "styled-components";
import { ThemeColor } from "../../../styles/theme";
import { BaseProps } from "../../index";
import { ButtonIconPosition } from "./IconButtonLayout";
import { device } from "../../../styles/media-query";

export interface ButtonBaseProps extends BaseProps {
  children: React.ReactNode | string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  font?: string;
  backgroundColor?: ThemeColor;
  fontColor?: string;
  tone?: number;
  color?: ThemeColor;
  rounding?: number;
  primary?: boolean;
  secondary?: boolean;
  size?: ButtonSize;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  fillWidth?: boolean;
  icon?: React.ReactNode;
  fillColor?: string;
  iconPosition?: ButtonIconPosition;
  hover?: boolean;
  fillBackground?: boolean;
  bold?: boolean;
  borderColor?: ThemeColor;
  border?: string;
}

export enum ButtonSize {
  LARGE = "lg",
  MEDIUM = "md",
  SMALL = "sm",
  XSMALL = "xs",
  LARGE_MOBILE = "lg_mobile",
  DROP_DOWN = "dropdown",
}

export const buttonStyleBySize: {
  [key in ButtonSize]: FlattenSimpleInterpolation;
} = {
  [ButtonSize.LARGE_MOBILE]: css`
    font-size: 18px;
    font-weight: 600;
    height: 52px;
    padding: 15px 16px;
  `,
  [ButtonSize.LARGE]: css`
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.2px;
    height: 56px;
    padding: 18px 16px;

    ${device.mobile} {
      height: 52px;
      font-size: 18px;
      padding: 15px 16px;
    }
  `,
  [ButtonSize.MEDIUM]: css`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.2px;
    height: 50px;
    padding: 13px 12px;
  `,
  [ButtonSize.SMALL]: css`
    font-size: 14px;
    letter-spacing: -0.2px;
    height: 39px;
    padding: 9px 12px;
  `,
  [ButtonSize.XSMALL]: css`
    font-size: 12px;
    font-weight: 400;
    letter-spacing: normal;
  `,
  [ButtonSize.DROP_DOWN]: css`
    font-size: 14px;
    height: 37px;
    padding: 8px 14px;
    font-weight: normal;
  `,
};

export const txtColorByButtonColor: { [key in ThemeColor]: ThemeColor } = {
  [ThemeColor.RED]: ThemeColor.WHITE,
  [ThemeColor.BLUE]: ThemeColor.WHITE,
  [ThemeColor.RED]: ThemeColor.WHITE,
  [ThemeColor.WHITE]: ThemeColor.PRIMARY,
  [ThemeColor.GRAY]: ThemeColor.WHITE,
  [ThemeColor.BLACK]: ThemeColor.WHITE,
  [ThemeColor.JBLACK]: ThemeColor.WHITE,
  [ThemeColor.PRIMARY]: ThemeColor.WHITE,
  [ThemeColor.DGRAY]: ThemeColor.WHITE,
  [ThemeColor.MGRAY]: ThemeColor.WHITE,
  [ThemeColor.LGRAY]: ThemeColor.WHITE,
  [ThemeColor.GRAY200]: ThemeColor.WHITE,
  [ThemeColor.GRAY300]: ThemeColor.WHITE,
  [ThemeColor.GRAY400]: ThemeColor.WHITE,
  [ThemeColor.JRED]: ThemeColor.WHITE,
  [ThemeColor.DBLUE]: ThemeColor.WHITE,
  [ThemeColor.MLGRAY]: ThemeColor.JBLACK,
  [ThemeColor.LIGHT_PURPLE]: ThemeColor.PRIMARY,
};

export interface WarpButtonInterface {}

export function getTxtColorByButtonColor() {}
